import { useContext, useEffect } from 'react';

import { loadStripe } from '@stripe/stripe-js/pure';

import { usePaymentsConfig } from '@/services/paymentsConfig/usePaymentsConfig';
import { ProvidersLibsDispatchContext } from '@/services/providersLibs/providersLibsContext';
import { useSelectedProvider } from '@/features/paymentSelect/useSelectedProvider';

function StripeLoader() {
  const providersLibsDispatch = useContext(ProvidersLibsDispatchContext);

  const { isSelectedProvider } = useSelectedProvider();

  const { getProviderStripePublicKey } = usePaymentsConfig();

  useEffect(() => {
    // Only load Stripe if it is the selected provider
    if (!isSelectedProvider('STRIPE')) {
      return;
    }

    // Wait for providers config to be loaded
    const stripePublicKey = getProviderStripePublicKey();
    if (!stripePublicKey) {
      return;
    }

    const stripePromise = loadStripe(stripePublicKey);

    providersLibsDispatch({
      stripePromise,
    });
  }, [
    isSelectedProvider,
    getProviderStripePublicKey,
    providersLibsDispatch,
  ]);

  return null;
}

export default StripeLoader;
